import { useCallback, useEffect, useRef } from 'react';
import { useAddUserItem } from './useUserItems';
import { useCurrentUser } from './useUserQuery';

export function useDeferredViewedListingMutation(): (alias: string) => void {
  const { data: currentUser } = useCurrentUser();
  const { mutate: addUserItem } = useAddUserItem();
  const pendingAliasesRef = useRef(new Set<string>());

  useEffect(() => {
    if (currentUser === undefined || pendingAliasesRef.current.size === 0) return;

    const pendingAliases = Array.from(pendingAliasesRef.current);
    pendingAliasesRef.current.clear();
    if (!currentUser?.loggedIn) return;

    for (const alias of pendingAliases) {
      addUserItem({ type: 'viewed', alias });
    }
  }, [addUserItem, currentUser]);

  return useCallback(
    (alias: string) => {
      if (currentUser === undefined) {
        pendingAliasesRef.current.add(alias);
        return;
      }

      if (currentUser?.loggedIn) {
        pendingAliasesRef.current.delete(alias);
        addUserItem({ type: 'viewed', alias });
      }
    },
    [addUserItem, currentUser],
  );
}
